document.querySelectorAll('.blog-post').forEach(post => {
  post.addEventListener('click', e => {
    // Avoid duplicate navigation if the actual <a> inside was clicked
    if (e.target.closest('a')) return

    const link = post.querySelector('a')
    if (link) window.location.href = link.href
  })
})

;(function () {
  const lang = document.documentElement.lang || 'en' // fallback to English
  
  const translations = {
    nl: {
      'Show Free Gift': 'Gratis Cadeau',
      'No Thanks': 'Nee Bedankt',
      'No, Thanks': 'Nee Bedankt',
      'Add to cart': 'Toevoegen'
    },
  }

  const translateTextNodes = () => {
    const elements = document.querySelectorAll('body *:not(script):not(style)')

    elements.forEach(el => {
      if (!el.childNodes || el.childNodes.length === 0) return

      el.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          const originalText = node.textContent.trim()
          const translated = translations[lang]?.[originalText]
          if (translated && node.textContent !== translated) {
            node.textContent = translated
          }
        }
      })
    })
  }

  // Initial run
  translateTextNodes()

  // Keep watching for injected content
  const observer = new MutationObserver(() => {
    translateTextNodes()
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  })
})()